type ScannedUpcCandidate = {
  rawValue?: string | null
  format?: string | null
}

export const getScannedUpcValue = (detectedCodes: ScannedUpcCandidate[] = []): string | null => {
  const scan = detectedCodes.find((code) => Boolean(code.rawValue?.trim()))

  if (!scan?.rawValue) {
    return null
  }

  return scan.rawValue.trim()
}
